module.exports = __webpack_public_path__ + "img/10-October.a851b119.jpg";